module.exports = __webpack_public_path__ + "static/img/_cgi-bin_mmwebwx-bin_webwxgetmsgimg__&MsgID=4802028223782932175&skey=@crypt_82e28dba_778beb39a2abee87d5992bb7b59bdfc4&mmweb_appid=wx_webfilehelper.be67fb9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_cgi-bin_mmwebwx-bin_webwxgetmsgimg__&MsgID=4802028223782932175&skey=@crypt_82e28dba_778beb39a2abee87d5992bb7b59bdfc4&mmweb_appid=wx_webfilehelper.jpeg
// module id = aMma
// module chunks = 1